import { TikTokIntegration } from 'api/clients/ExternalIntegrationsClient'
import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { LikeIcon, CommentIcon, BookmarkIcon, ShareIcon } from './icons'
import { Plus02 } from 'blaze-ui/icons'
import Styles from './TikTokPreview.module.scss'

interface ActionsProps {
  integration?: TikTokIntegration
}

export const Actions = ({ integration }: ActionsProps) => {
  const { username, avatar } = integration
    ? extractProfileInfo(integration)
    : { username: 'user', avatar: Silhouette }

  return (
    <div className={Styles.actions}>
      <div className={Styles.avatarContainer}>
        <img src={avatar || Silhouette} alt={username} className={Styles.avatar} />
        <div className={Styles.plusIcon}>
          <Plus02 color="white" size={14} />
        </div>
      </div>
      <div className={Styles.action}>
        <LikeIcon />
        <span>223</span>
      </div>
      <div className={Styles.action}>
        <CommentIcon />
        <span>23</span>
      </div>
      <div className={Styles.action}>
        <BookmarkIcon />
        <span>10</span>
      </div>
      <div className={Styles.action}>
        <ShareIcon />
        <span>3</span>
      </div>
      <img src={avatar || Silhouette} alt={username} className={Styles.profile} />
    </div>
  )
}
